import { ref } from "vue";
import { useAuthenticatedFetch } from "../auth/useAuthenticatedFetch";
import { Income, IncomeRequest, IncomeSearchParams } from "@/interfaces/income";
import {
  incomes,
  clubUUID,
  paginationLinks,
  summary_incomes,
} from "@/shared/state";
import { useModal } from "@/composables/modal/useModal";
const { authenticatedFetch } = useAuthenticatedFetch();
const API_URL = process.env.VUE_APP_ROOT_API;
export function useIncome() {
  const errorIncome = ref<boolean | false>(false);
  const isRequestIncome = ref<boolean | false>(false);
  const { closeModal } = useModal();
  const getIncomes = async (body: IncomeSearchParams) => {
    try {
      isRequestIncome.value = true;
      errorIncome.value = false;
      paginationLinks.value = 0;
      const response = await authenticatedFetch(
        `${API_URL}incomes/search`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        false,
        "",
        false,
      );

      if (response) {
        //  incomes.data = response?.data?.incomes || [];
        if (body?.type === "paginate") {
          summary_incomes.data = response?.summary[0] || {};
          incomes.data = response?.incomes?.data || [];
          paginationLinks.value = response?.incomes || [];
          delete paginationLinks.value.data;
        } else if (body?.type === "all") {
          if (response?.summary) {
            summary_incomes.data = response?.summary || {};
            incomes.data = response?.incomes || {};
          } else {
            incomes.data = response || {};
          }
        }
      }
      isRequestIncome.value = false;
    } catch (err: any) {
      errorIncome.value = true;
      isRequestIncome.value = false;
    }
  };

  const addIncome = async (body: IncomeRequest) => {
    try {
      isRequestIncome.value = true;
      errorIncome.value = false;
      const response = await authenticatedFetch(
        `${API_URL}incomes/store`,
        {
          method: "POST",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response?.data) {
        const incomeAdded: Income = response?.data;
        incomes?.data?.unshift(incomeAdded);
        closeModal("modal_add_income", "add");
      }
      isRequestIncome.value = false;
    } catch (err: any) {
      errorIncome.value = true;
      isRequestIncome.value = false;
    }
  };

  const editIncome = async (body: IncomeRequest) => {
    try {
      isRequestIncome.value = true;
      errorIncome.value = false;
      const response = await authenticatedFetch(
        `${API_URL}incomes/edit/${body?.id}`,
        {
          method: "PUT",
          body: JSON.stringify(body),
        },
        true,
        "",
        true,
      );
      if (response) {
        const incomeEdited: Income = response?.data;
        const index = incomes?.data?.findIndex(
          (income) => income?.id === incomeEdited?.id,
        );
        if (index !== -1) {
          incomes.data[index] = incomeEdited;
        }
      }
      isRequestIncome.value = false;
    } catch (err: any) {
      errorIncome.value = true;
      isRequestIncome.value = false;
    }
  };

  const deleteIncome = async (id: number) => {
    try {
      isRequestIncome.value = true;
      errorIncome.value = false;
      const response = await authenticatedFetch(
        `${API_URL}incomes/delete/${id}`,
        {
          method: "DELETE",
        },
        true,
        "",
        true,
      );
      const index = incomes?.data?.findIndex((income) => income?.id === id);
      if (index !== -1) {
        incomes.data.splice(index, 1);
      }
      isRequestIncome.value = false;
    } catch (err: any) {
      errorIncome.value = true;
      isRequestIncome.value = false;
    }
  };

  return {
    getIncomes,
    addIncome,
    editIncome,
    deleteIncome,
    isRequestIncome,
    errorIncome,
  };
}
